import { State, Dispatch } from '../State';
import { resolveThemeContext, resolveComponentAndChildComponents } from '../resolve-component';
import { dispatchScopeEvent as scopeEventDispatch } from '../events';
import { Action } from 'redux';

export const SET_THEME_NAME = 'SET_THEME_NAME';

export type SetThemeNameAction = Action & {
  themeName: string;
};

/**
 * Note! Calling this method will only update the theme in-memory. If the user reloads
 * the page it will revert to either the default theme or whatever theme the backend says
 * we should use. If you need to persist the theme change when it occurs in the frontend
 * you need to sync that with your backend.
 *
 * For most use case the backend should decide which theme that should be the current theme.
 */
export function setTheme(themeName: string) {
  return (dispatch: Dispatch, getState: () => State) => {
    const action: SetThemeNameAction = {
      type: SET_THEME_NAME,
      themeName: themeName || '',
    };
    return resolveComponentAndChildComponents(getState().currentPage, themeName).then(() => {
      const dispatchAction = () => {
        scopeEventDispatch(action);
        return dispatch(action);
      };
      if (!themeName) {
        return dispatchAction();
      } else {
        return resolveThemeContext(themeName).then(() => dispatchAction());
      }
    });
  };
}
